export default __webpack_public_path__ + "scala.5453c629.png";